module.exports = __webpack_public_path__ + "static/p6-aac9f26c5550b7fc9436987046b19c32.png";